import { BASE_TITLE } from "./CONSTS";

/**
 * Prefixes browser tab titles with the selected institute name when present,
 * e.g. "Varisht - Branding" → "ABC School - Branding".
 */
export function withInstituteTabTitle(
  instituteName: string | null | undefined,
  productTitle: string,
): string {
  if (!instituteName?.trim()) return productTitle;
  const trimmedName = instituteName.trim();
  const rest = productTitle.startsWith(BASE_TITLE)
    ? productTitle.slice(BASE_TITLE.length).trimStart()
    : productTitle;
  return `${trimmedName} - ${rest}`;
}
